<template>
    <div class="footer">
        <div class="somfonds-disclaimer">
            <p>Alle eenheden binnen de koepel van FOS Open Scouting bieden kortingstarieven aan op lid- en kampgelden,
                dit via het SOMfonds.</p>
            <p>Tal van de eenheden in Gent bieden daarnaast nog extra kortingen aan via de eigen eenheid. Informatie
                hierover kan steeds worden opgevraagd via de eenheidsleid(st)ers.</p>
        </div>
        <div class="icons--gent"></div>
    </div>
</template>

<script>
    export default {
        name: 'EntityFooter',
    }
</script>

<style scoped>
    .somfonds-disclaimer {
        background-color: rgba(140, 204, 213, .1);
        padding: 40px;
        font-family: 'AndesBook', Helvetica, Arial, sans-serif;
        color: #005C9C;
        font-size: 19px;
    }

    .icons--gent {
        display: inline-block;
        width: 100%;
        background-image: url('../../assets/images/gent.svg');
        background-repeat: no-repeat;
        background-size: auto 50%;
        background-position: 40px 40px;
        height: 120px;
    }
</style>



// WEBPACK FOOTER //
// src/components/entities/Footer.vue